import { takeLatest, call, put } from 'redux-saga/effects';
import {
  GET_EPF_PAYMENT_URL,
  SET_EPF_PAYMENT_URL_LOADING,
  SET_TRANSACTION,
} from 'redux/reducers/payment/actionTypes';
import {
  SET_OPEN_TOP_ALERT,
  SET_CONTENT_TOP_ALERT,
} from 'redux/reducers/global/actionTypes';
import { paymentUrlEPFService } from 'services/payment/paymentApi';

function* requestPaymentFromEPF(action) {
  yield put({ type: SET_EPF_PAYMENT_URL_LOADING });
  let result: any = yield call(paymentUrlEPFService, action.body);
  if (result && result.response && result.error) {
    const topAlertContent = {
      iconType: 'la la-exclamation-circle',
      message: `Sorry, ${result.response.status} ${result.response.statusText}`,
      iconClose: 'la la-times',
    };
    yield put({ type: SET_CONTENT_TOP_ALERT, topAlertContent });
    yield put({ type: SET_OPEN_TOP_ALERT });
    return;
  }
  yield put({ type: SET_TRANSACTION, result });
  yield put({ type: SET_EPF_PAYMENT_URL_LOADING });
}
function* getPaymentUrlFromEPF() {
  yield takeLatest(GET_EPF_PAYMENT_URL, requestPaymentFromEPF);
}

export default getPaymentUrlFromEPF;
